// PROD
export const BACKEND_URL = `https://2bsk23rzexa3isfazynnj7cywu0pyocc.lambda-url.us-east-1.on.aws/`
